import { lazy } from "react";
import { RouteConfig } from "../../../../types/RouteConfig";

export const calorClaimFormRoute: RouteConfig<'with-page'> = {
    name: 'Claim Form',
    path: '/rewards/calor/claim-form',
    page: lazy(() => import('.')),
    flags: ['member-route'],
    permissions: ['rewards'],
    context: 'member',
}